export default class YoutubePlayer {
    static init() {
        const youtubePlayers = document.querySelectorAll('.youtube-player');
        if (!youtubePlayers.length) {
            return;
        }

        window.addEventListener('CookiebotOnConsentReady', () => {
            if (this.preferenceCookiesAreAllowed()) {
                YoutubePlayer.loadScript();
            }
        });
        Array.prototype.forEach.call(youtubePlayers, el => {
            new YoutubePlayer(el);
        });
    }

    static preferenceCookiesAreAllowed() {
        return window.Cookiebot ? window.Cookiebot.consent.preferences : false;
    }

    static loadScript() {
        let tag = document.createElement('script');
        let firstScriptTag = document.getElementsByTagName('script')[0];

        tag.src = 'https://www.youtube.com/iframe_api';
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

	static classes = {
		node: 'youtube-player',
		get overlay() {
			return this.node + '__overlay'
		},
        get cookieConsentOverlay() {
            return this.node + '__cookie-consent-overlay'
        },
		get iframe() {
			return this.node + '__iframe'
		},
		state: {
			get initialised() {
				return YoutubePlayer.classes.node + '--is-initialized'
			},
			get unstarted() {
				return YoutubePlayer.classes.node + '--is-unstarted'
			},
			get ended() {
				return YoutubePlayer.classes.node + '--is-ended'
			},
			get playing() {
				return YoutubePlayer.classes.node + '--is-playing'
			},
			get paused() {
				return YoutubePlayer.classes.node + '--is-paused'
			},
			get buffering() {
				return YoutubePlayer.classes.node + '--is-buffering'
			},
			get cued() {
				return YoutubePlayer.classes.node + '--is-cued'
			}
		}
	}

	constructor(element) {
		this.options = '';
		this.element = element;
		this.iframe = element.querySelector('.' + YoutubePlayer.classes.iframe);
		this.overlay = element.querySelector('.' + YoutubePlayer.classes.overlay);
        this.cookieConsentOverlay = element.querySelector('.' + YoutubePlayer.classes.cookieConsentOverlay);
		this.state = 'unstarted';
		this.isInitialised = false;

        if (YoutubePlayer.preferenceCookiesAreAllowed()) {
            this.cookieConsentOverlay.style.display = 'none';
        } else {
            this.cookieConsentOverlay.addEventListener('click', () => window.Cookiebot.renew());
            window.addEventListener('CookiebotOnConsentReady', () => {
                if (YoutubePlayer.preferenceCookiesAreAllowed()) {
                    this.cookieConsentOverlay.style.display = 'none';
                }
            });
        }
		this.overlay.addEventListener('click', () => this.startPlayer());
	}

    onPlayerApiReady(fn) {
        if (window.YT && window.YT.Player) {
            fn();
        } else {
            setTimeout(() => this.onPlayerApiReady(fn), 100);
        }
    }

    startPlayer() {
        if (document.body.classList.contains('neos-backend')) {
            return;
        }
        if (this.isInitialised) {
            this.YTPlay();
            return;
        }
        this.setState('initialised');
        this.isInitialised = true;
        this.player = this.createPlayer(this.iframe);
    }

	createPlayer(playerNode) {
		let options = {
			videoId: this.iframe.dataset.id,
			origin: this.iframe.dataset.origin,
			hl: this.iframe.dataset.language,
			iv_load_policy: 3,
			modestbranding: 1,
			showinfo: 0,
			rel: 0,
			enablejsapi: 1,
			playsinline: 1,
			autohide: 1,
			controls: 0,
			playlist: this.iframe.dataset.id
		}

		return new YT.Player(playerNode, {
			events: {
				'onReady': () => {
					this.YTPlay();
				},
				'onStateChange': (event) => {
					switch (event.data) {
						case -1:
							this.setState('unstarted');
							break;
						case 0:
							this.setState('ended');
							break;
						case 1:
							this.setState('playing');
							break;
						case 2:
							this.setState('paused');
							break;
						case 3:
							this.setState('buffering');
							break;
						case 5:
							this.setState('cued');
							break;
					}
				}
			},
			...options
		});
	}

	setState(state) {
		let stateClass = YoutubePlayer.classes.state[state];
		if (this.element.classList.contains(stateClass)) return;

		for (let key in YoutubePlayer.classes.state) {
			if (key !== 'initialised') {
				this.element.classList.remove(YoutubePlayer.classes.state[key]);
			}
		}
		this.state = state;
		this.element.classList.add(stateClass);
	}

	YTPlay() {
		this.player.playVideo();
		this.setState('playing');
	}

	YTPause() {
		this.player.pauseVideo();
		this.setState('paused');
	}

	YTStop() {
		this.player.stopVideo();
		this.setState('stopped');
	}
}

YoutubePlayer.init();
